module.exports = __webpack_public_path__ + "static/media/frt.a5a4f19d.svg";